<template>
  <div>
    <!-- <current-path /> -->
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("headings.airport") }}</v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn :to="{ name: 'create-airport' }" large class="primary">
        {{ $t("button.create") }}
        <v-icon right>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      @on_dialog_close="onDialogClose"
      @get_items="getItems"
      ref="table_ref"
      :headersName="headers"
      pathName="airports"
      resName="airports"
      class="table-row"
      dialogWidth="500"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          {{ item.name }}
        </td>
        <td class="text-sm-center">
          {{ item.tourism_city && item.tourism_city.name }}
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="airports"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="text-sm-center">
          {{ convertDate(item.created_at) }}
        </td>
        <td class="text-sm-center">
          <v-btn icon :to="`/airports/edit/${item.id}`">
            <v-icon color="info" :title="$t('icon.edit')" small
              >mdi-pencil</v-icon
            >
          </v-btn>
          <v-icon
            color="error"
            @click="handleDelete(item, index)"
            :title="$t('icon.delete')"
            small
            >mdi-delete</v-icon
          >
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </div>
</template>

<script>
import cookie from "js-cookie";
import { ShowData } from "@/helpers/apiMethods";
export default {
  name: "Airports",

  data() {
    return {
      headers: ["name", "tourism_city", "visible", "created_at", "actions"],
      isEdit: false,
      loadingButton: false,
      items: [],
      item: {},
      itemIndex: "",
      locale: cookie.get("language") || "en",

      toggleQueries: {
        query: {
          seen: "",
          closed: ""
        }
      }
    };
  },
  methods: {
    ClearAllFilters() {
      this.$refs.toggle_filter_ref.ClearFilter();
      this.$router.push({ query: {} });
    },

    onDialogClose() {
      this.isEdit = false;
      this.$refs.table_ref.handleGetItems(this.$route.query);
    },

    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    handleShow(item, index) {
      this.isEdit = true;
      this.item = item;
      this.itemIndex = index;
      this.$refs.table_ref.toggleDialog();
      this.handleShowData();
    },
    getItems(items) {
      this.items = items;
    },

    handleShowData() {
      ShowData({ reqName: "banners", param: this.item.id })
        .then(res => {
          const { flight_form } = res.data;
          this.item = flight_form;
        })
        .catch(err => console.log(err));
    }
  }
};
</script>
